@if (manualQuoteTypeList) {
  <p-select
    [appendTo]="'body'"
    (onChange)="onManualQuoteTypeChange($event)"
    [options]="manualQuoteTypeList"
    [(ngModel)]="manualQuoteType"
    [filter]="true"
    filterBy="label, value"
    [disabled]="disabled()"
    [placeholder]="manualQuoteType"
  >
  </p-select>
}
